import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const http = axios.create({
  baseURL: API,
  timeout: 15000,
});

export const api = {
  products: () => http.get("/products").then((r) => r.data),
  product: (handle) => http.get(`/products/${handle}`).then((r) => r.data),
  reviews: () => http.get("/reviews").then((r) => r.data),
  posts: () => http.get("/posts").then((r) => r.data),
  post: (slug) => http.get(`/posts/${slug}`).then((r) => r.data),
  createCart: () => http.post("/cart").then((r) => r.data),
  getCart: (id) => http.get(`/cart/${id}`).then((r) => r.data),
  addLine: (id, payload) => http.post(`/cart/${id}/items`, payload).then((r) => r.data),
  updateLine: (id, payload) => http.patch(`/cart/${id}/items`, payload).then((r) => r.data),
  removeLine: (id, variantId) => http.delete(`/cart/${id}/items/${variantId}`).then((r) => r.data),
  checkout: (id) => http.post(`/cart/${id}/checkout`).then((r) => r.data),
  waitlist: (payload) => http.post("/waitlist", payload).then((r) => r.data),
  newsletter: (payload) => http.post("/newsletter", payload).then((r) => r.data),
  investorInquiry: (payload) => http.post("/investor-inquiry", payload).then((r) => r.data),
  sampleFeedback: (payload) => http.post("/sample-feedback", payload, { timeout: 45000 }).then((r) => r.data),
  sampleInvite: (payload) => http.post("/sample-invite", payload, { timeout: 45000 }).then((r) => r.data),
  shopifyStatus: () => http.get("/shopify/status").then((r) => r.data),
};
